/** item 4 · PWA 會議紀錄清單（公司會議室 ee_office_meeting·依會議身分可讀的紀錄）。
 *  手機首頁「會議紀錄」磚（system_functions.ee_office_minutes·mobile_path）導向此頁。 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Card, CardActionArea, Chip, Stack, Typography } from '@mui/material';

import { useMessage } from '../../../contexts/MessageContext';
import { formatLocalDate } from '../../../utils/dateHelper';
import { listMyMinutes, MinutesListItem } from '../officeMeeting/services/officeMeetingService';

const OfficeMinutesListPage: React.FC = () => {
  const nav = useNavigate();
  const { t } = useTranslation();
  const tt = (k: string, d: string) => t(`pwaMinutes.${k}`, d);
  const { showApiError } = useMessage();
  const [rows, setRows] = React.useState<MinutesListItem[]>([]);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    listMyMinutes()
      .then(setRows)
      .catch(showApiError)
      .finally(() => setLoaded(true));
  }, [showApiError]);

  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Typography variant="h6" sx={{ fontWeight: 700 }}>📝 {tt('listTitle', '會議紀錄')}</Typography>
      {loaded && rows.length === 0 && (
        <Typography variant="body2" color="text.disabled">{tt('empty', '目前沒有可檢視的會議紀錄')}</Typography>
      )}
      {rows.map((r) => (
        <Card key={r.id} variant="outlined">
          <CardActionArea onClick={() => nav(`/ee_pwa_minutes/${r.id}`)} sx={{ p: 1.5 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body2" sx={{ fontWeight: 600 }}>{r.title}</Typography>
              {r.can_edit_minutes && <Chip size="small" color="primary" label={tt('editable', '可編輯')} />}
            </Stack>
            <Typography variant="caption" color="text.secondary">
              {formatLocalDate(r.start_at)} · {r.meeting_no}
              {r.chair_name ? ` · ${tt('chair', '主席')}：${r.chair_name}` : ''}
            </Typography>
            {r.summary && (
              <Typography variant="body2" color="text.secondary"
                sx={{ mt: 0.5, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                {r.summary}
              </Typography>
            )}
          </CardActionArea>
        </Card>
      ))}
    </Box>
  );
};

export default OfficeMinutesListPage;
